export default function getPropertyValueInputs(properties) {
  return Object.entries(properties).map(([propertyName, property]) => ({
    name: propertyName,
    value: property.value
  }));
}